/// <reference types="vite/client" />
import React from 'react';
import ReactDOM from 'react-dom/client';
import AppV2 from './v2/AppV2.tsx';
import './globals.css';

const BOT_LINK = 'https://t.me/NomaAiBot';

function isInsideTelegram(): boolean {
  try {
    return Boolean(window.Telegram?.WebApp?.initData);
  } catch {
    return false;
  }
}

function TelegramGate() {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
        background: '#f5f5fa',
      }}
    >
      <div
        style={{
          maxWidth: '340px',
          textAlign: 'center',
          background: '#ffffff',
          borderRadius: '28px',
          padding: '36px 28px',
          boxShadow: '0 18px 48px rgba(17, 17, 19, 0.08)',
        }}
      >
        <div style={{ fontSize: '44px', lineHeight: 1 }}>🥑</div>
        <h1 style={{ margin: '18px 0 0', fontSize: '22px', fontWeight: 900, letterSpacing: '-0.04em', color: '#111113' }}>
          Noma работает в Telegram
        </h1>
        <p style={{ margin: '12px 0 0', fontSize: '14px', fontWeight: 600, lineHeight: 1.5, color: 'rgba(32,32,32,0.64)' }}>
          Это мини-приложение открывается только внутри Telegram. Запусти бота — и приложение откроется само.
        </p>
        <a
          href={BOT_LINK}
          style={{
            display: 'block',
            marginTop: '24px',
            padding: '16px',
            borderRadius: '18px',
            background: 'linear-gradient(135deg, #8b63ff, #7f54ff)',
            color: '#ffffff',
            fontSize: '15px',
            fontWeight: 800,
            textDecoration: 'none',
          }}
        >
          Открыть @NomaAiBot
        </a>
      </div>
    </div>
  );
}

function AppShell() {
  React.useEffect(() => {
    try {
      localStorage.removeItem('miniapp_ui_version');

      const url = new URL(window.location.href);
      if (url.searchParams.has('ui')) {
        url.searchParams.delete('ui');
        window.history.replaceState({}, '', url.toString());
      }
    } catch {
      // noop
    }
  }, []);

  // В браузере без Telegram приложение не показываем (в dev-режиме Vite — показываем)
  if (!import.meta.env.DEV && !isInsideTelegram()) {
    return <TelegramGate />;
  }

  return <AppV2 />;
}

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(<AppShell />);

requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    document.documentElement.classList.add('transitions-enabled');
  });
});
